module.exports = __webpack_public_path__ + "static/media/mapBackground.87f1fdc7.jpg";